import React, {FC} from "react";

export const Only: FC<{ when: boolean, children: any }> = (props) => {
    return props.when ? props.children : <></>;
};
